/**
 * @description
 * Intercepta todas las llamadas http y comprueba si el token ha expirado.
 */

import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable()
export class TokenExpiredInterceptor implements HttpInterceptor {
  constructor(
    private jwtHelper: JwtHelperService,
    private _router: Router
  ) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('JWT');
    const llamadaHttp = req.url;

    if (llamadaHttp.includes('/api/accesoCiudadano') || llamadaHttp.includes('/api/accesoSimpleCiudadano')) {
      return next.handle(req);
    }

    if (this.jwtHelper.isTokenExpired(token)) {
      Swal.fire({
        title: 'Su sesión ha expirado, se le reenviará a la pantalla de inicio.',
        timer: 2000,
      });
      this._router.navigate(['inicio']);
    }
    return next.handle(req);
  }
}
